import React from 'react';
import authRoles from '../../../auth/authRoles';
import Gallery from './Gallery';
import AlbumDetail from './AlbumDetail';

const GalleryConfig = {
	gallery: {
		layout: {
			config: {},
		},
	},
	routes: [
		{
			path: '/memories',
			element: (
				<React.Suspense fallback={<>...</>}>
					<Gallery />
				</React.Suspense>
			),
		},
		{
			path: '/memories/albums',
			element: (
				<React.Suspense fallback={<>...</>}>
					<Gallery />
				</React.Suspense>
			),
		},
		{
			path: '/memories/albums/:albumId',
			element: (
				<React.Suspense fallback={<>...</>}>
					<AlbumDetail />
				</React.Suspense>
			),
		},
	],
	auth: authRoles.subadmin,
};

export default GalleryConfig;
